import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { CommonService } from './../../../services/common/common.service';
import { CppPriceListService } from './../../../services/cpp/cpp-price-list.service';
import { MasterConstants } from './../../../common/constants/master-constants';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-price-list-lookup-grid',
  templateUrl: './cpp-price-list-lookup-grid.component.html',
  styleUrl: './cpp-price-list-lookup-grid.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class CppPriceListLookupGridComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  @ViewChild('priceListPaginator', { read: MatPaginator }) priceListPaginator: MatPaginator;
  cppProductListDataSource: MatTableDataSource<any>;
  mainProductList: any = [];
  priceListCPPColumns: string[] = ['product', 'price'];
  searchTypeList = ['Product Name'];
  productNameSearchList: Array<any> = [];
  filterValueList = new Array();
  headerCompany = MasterConstants.US_COMPANYCODE;
  selectedValue: string = this.searchTypeList[0];
  productFilters: any;
  masterConstants = MasterConstants;
  productNameInput = '';
  readOnlyAccess = false;
  disableFilterBtn = true;
  accountNo = 0;
  accountName: string;
  userMenuAccessList: any;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private cppPriceListService: CppPriceListService,
    private commonService: CommonService
  ) {

    // Set account number if passed in url

    this.subscription.push(this.activeRoute.params.subscribe(params => {
      const id = params['accountNo'];
      this.accountNo = id ? id : 0;
    }));
  }

  // Page initilization code
  ngOnInit() {
    this.accountName = this.cppPriceListService.accountName;
    this.resetProductFilter();

    if (this.localStorageService.get(MasterConstants.CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS)) {
      this.productNameSearchList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS));
      this.productNameSearchList = this.productNameSearchList.map(a => a.id);
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        } else {
          this.router.navigate(['/unauthorize']);
        }
      }
    }
  }

  // Called after component view is fully initialized isSpecialPriceListDisplayed
  ngAfterViewInit() {
    this.setPriceListTableHeight();
  }

  // Reset the filter values
  public resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'accountNo': 0,
      'productName': ''
    };
  }

  // Set Table height dynamically
  setPriceListTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.topSection').outerHeight() - $('.price-disclaimer').outerHeight() - $('.fulfill-top-sec').outerHeight() - 180;
      $('.priceListTable').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Get Cpp Product list
  getCPPProductData() {
    if ((this.productFilters.productName?.trim()?.length || 0) >= 3) {
      this.loaderService.setLoaderStatus(true);
      this.productFilters.accountNo = this.accountNo;


      this.subscription.push(this.cppPriceListService.getCPPProductData(this.productFilters).subscribe((result: any[]) => {
        this.mainProductList = result;
        this.cppProductListDataSource = new MatTableDataSource(this.mainProductList);
        this.cppProductListDataSource.paginator = this.priceListPaginator;
        this.cppProductListDataSource.paginator.firstPage();
        setTimeout(() => {
          this.loaderService.setLoaderStatus(false);
        }, 1000);
      }, error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.info(error);
      }));
    }

  }

  // For the row that needs to be highlighted as group header
  isGroup(index, item): boolean {
    return item.isGroup;
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.filterValueList) {
      this.filterValueList = [];
      if (this.productFilters) {
        this.matChipDisplay('Product Name', this.productFilters.productName);
      }

      if (this.filterValueList.length > 0) {
        this.disableFilterBtn = false;
      } else {
        this.disableFilterBtn = true;
      }
    }

  }

  // Display text on MatChip for text filter
  matChipDisplay(label, property): string {
    if (property) {
      const productNames = property.trim().split(',');
      if (productNames && productNames.length > 0) {
        productNames.forEach(x => {
          if (x) { this.filterValueList.push(label + ' : ' + x); }
        });
      } else {
        this.filterValueList.push(label + ' : ' + property);
      }
    }
    return property;
  }


  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.setPriceListTableHeight();
    this.mainProductList = [];
    this.cppProductListDataSource = new MatTableDataSource(this.mainProductList);
    this.cppProductListDataSource.paginator = this.priceListPaginator;
    this.cppProductListDataSource.paginator.firstPage();
  }

  updatedVal(e) {
    this.productFilters.productName = (e || '').trim();
    this.validateProductSearch(this.productFilters.productName);
  }

  validateProductSearch(toValidateInput: any) {
    // To Validate Brand
    if ((toValidateInput !== null && toValidateInput !== '' && toValidateInput.toString().trim().length >= 3)
      || this.productFilters.productName !== null && this.productFilters.productName !== '' && this.productFilters.productName.toString().trim().length >= 3
    ) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }
  }

  validateProduct(e) {
    e = (e || '').trim();
    this.productFilters.productName = e;
    if (e !== null && e !== '' && e.length > 2) {
      this.disableFilterBtn = false;
    } else {
      this.disableFilterBtn = true;
      this.productFilters.productName = '';
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
